import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GroupingLists } from '@classes/grouping/grouping-lists';
import { ReportSelectGroup } from '@classes/report/report-select-group';
import { UiService } from '@services/ui.service';
import { ReportMode } from '@enums/report-mode.enum';
import { OriginService } from '@services/origin.service';

@Component({
    selector: 'app-report-compare',
    templateUrl: './report-compare.component.html',
    styleUrls: ['./report-compare.component.scss']
})
export class ReportCompareComponent implements OnInit {
    selectGroups: ReportSelectGroup[];
    reportMode = ReportMode;

    years: number[];

    constructor(
        private route: ActivatedRoute,
        private uiSrv: UiService,
        private originSrv: OriginService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.originSrv.get()
        .subscribe(origin => {
            if (origin.provider.code !== 'bbc2020')
            {
                this.years = origin.lastYears
                    .map(y => y.year)
                    .filter((value, index, self) => self.indexOf(value) === index) // distinct
                    .sort();
            }
        });

        this.route.data
        .subscribe((data: { groups: GroupingLists }) => {
            this.selectGroups = [{
                label: this.uiSrv.translate('grouping.list.userGroups.shortLabel'),
                items: data.groups.groups
            }, {
                label: this.uiSrv.translate('grouping.list.templateGroups.shortLabel'),
                items: data.groups.publicGroups
            }];
        });
    }
}
